import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { ManageFootballCompetitionInvitation } from "../../../../../../commons/models/football/admin/manage-football-competition-invitation";
import { EnsueCollection } from "../../../../../../ensue-react-system/utilities/ensue-collection";

export interface IManageTeamCompetitionInviteState {
  teamCompetitionInvitations: EnsueCollection<ManageFootballCompetitionInvitation>;
  teamCompetitionInvitationsStatus: StatusEnum;
}

const initialState: IManageTeamCompetitionInviteState = {
  teamCompetitionInvitations: new EnsueCollection<ManageFootballCompetitionInvitation>(),
  teamCompetitionInvitationsStatus: StatusEnum.Idle,
};

export const fetchManageTeamCompetitionInvites = createAsyncThunk(
  "manage/teamCompetitionInvitations",
  async (teamId: number, thunkAPI) => {
    try {
      const teamCompetitionInvitations = await manageFootballTeamService.getTeamCompetitionInvites(teamId);
      return teamCompetitionInvitations as EnsueCollection<ManageFootballCompetitionInvitation>;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageTeamCompetitionInvitesSlice = createSlice({
  name: "footballManageTeamCompetitionInvites",
  initialState: initialState,
  reducers: {
    cleanUpTeamCompetitionInvites(state) {
      state.teamCompetitionInvitations = new EnsueCollection<ManageFootballCompetitionInvitation>();
      state.teamCompetitionInvitationsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageTeamCompetitionInvites.pending, (state) => {
        state.teamCompetitionInvitationsStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageTeamCompetitionInvites.fulfilled,
        (state, action: PayloadAction<EnsueCollection<ManageFootballCompetitionInvitation>>) => {
          state.teamCompetitionInvitationsStatus = StatusEnum.Succeeded;
          state.teamCompetitionInvitations = action.payload;
        }
      )
      .addCase(fetchManageTeamCompetitionInvites.rejected, (state) => {
        state.teamCompetitionInvitationsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamCompetitionInvites } = footballManageTeamCompetitionInvitesSlice.actions;
export default footballManageTeamCompetitionInvitesSlice.reducer;
